import axios from 'axios';
import { payload } from 'src/api/calendar';
// config
import { baseURL } from 'src/config-global';
// ----------------------------------------------------------------------
const axiosInstance = axios.create({ baseURL: baseURL });
const authToken = localStorage.getItem('authToken');
const projectId = localStorage.getItem('projectId');
const companyId = localStorage.getItem('companyId');
axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);
export default axiosInstance;
// ----------------------------------------------------------------------
export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.get(url, {
    headers: apiHeader,
    ...config,
  });
  return res.data;
};

export const tokenGetter = () => {
  const searchParams = new URLSearchParams(window.location.search);
  // console.log(localStorage.getItem('authToken'));
  // console.log(`Bearer ${searchParams.get('token') || localStorage.getItem('authToken')}` || '');
  return `Bearer ${searchParams.get('token') || localStorage.getItem('authToken')}` || '';
};


const currentprojectid = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('project_id') || localStorage.getItem('projectId') || '';
};
export const currentCompanyId = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('company_id') || localStorage.getItem('companyId') || '';
};
export const simpleHeader = {
  Authorization: tokenGetter(),
  currentprojectid: currentprojectid(),
  currentCompanyId: currentCompanyId(),
};

export const apiHeader = {
  Accept: 'application/json',
  Authorization: tokenGetter(),
  currentCompanyId: currentCompanyId(),
  currentProjectId: currentprojectid(),
};
export const apiPostHeader = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: tokenGetter(),
  currentCompanyId: currentCompanyId(),
  currentProjectId: currentprojectid(),
};

export const multipartPartFormDataHeader = {
  'Content-Type': 'multipart/form-data',
  Accept: 'application/json',
  Authorization: tokenGetter(),
  currentCompanyId: currentCompanyId(),
  currentProjectId: currentprojectid(),
};

// new headers
export const simpleHeaderFn = () => ({
  Authorization: tokenGetter(),
  currentprojectid: currentprojectid(),
  currentCompanyId: currentCompanyId(),
});

export const apiPostHeaderFn = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: tokenGetter(),
  currentCompanyId: currentCompanyId(),
  currentProjectId: currentprojectid(),
});

export const multipartPartFormDataHeaderFn = () => ({
  'Content-Type': 'multipart/form-data',
  Accept: 'application/json',
  Authorization: tokenGetter(),
  currentCompanyId: currentCompanyId(),
  currentProjectId: currentprojectid(),
});
// ----------------------------------------------------------------------
const userProjectsID = currentprojectid();
// ----------------------------------------------------------------------
export const endpoints = {
  fetchMessages: '/chat/fetchMessages',
  fetchCompanyMessages: '/company-chat/fetchMessages',
  chat: '/api/chat',
  users: '/users',
  getProjectUsers: '/chat/contacts',
  getLead: '/company/leads',
  editLead: '/company/leads',
  getCompanyUsers: '/company-chat/company-contacts',
  conversationContact: '/chat/conversations',
  companyconversationContact: '/company-chat/conversations',
  chatAttachments: '/chat/chat-attachments?to_id=',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  bids_due: '/company/calendar/bids',
  leads_due: '/company/calendar/leads',
  project_due: '/company/calendar/projects',
  planned_cost_code: '/project/calendar/planned-cost-codes',
  performed_cost_code: '/project/calendar/performed-cost-codes',
  company_project: '/user/company-project',
  profile_info: '/profile',
  chat_details: '/get-current-company-project',
  risk_management: {
    risk_dashboard: {
      dashboardData: '/risk-management/risk-dashboard',
      monthYear: '/risk-management/dashboard-risk-trend',
      heatmap: '/risk-management/dashboard-heatmap',
    },
    risk_register: {
      identification: {
        identification: '/risk-management/identification-and-assessments',
        importFile: '/risk-management/identification-assessment-import',
        bulk_delete: '/risk-management/identification-assessment-bulk-delete',
        settings: '/risk-management/identification-assessment-settings',
        show: (id) => `/risk-management/identification-and-assessments/${id}`,
        project_stages: '/risk-management/project-stages',
        app_role: '/app/project-roles',
        risk_categories: '/risk-management/risk-categories',
        risk_owners: '/risk-management/risk-owners',
        get_risk_owners_users: `/users?project_id=${userProjectsID}`,
        create_risk_owners: '/users',
        AddUserID: `/users?project_id=${userProjectsID}`,
        risk_assessments: (id) =>
          `/risk-management/identification-and-assessment/${id}/risk-assessments`,
        risk_analyses: (id) => `/risk-management/identification-and-assessment/${id}/risk-analyses`,
        mitigation_plans: (id) =>
          `/risk-management/identification-and-assessment/${id}/mitigation-plans`,
        monitor_and_tracks: (id) =>
          `/risk-management/identification-and-assessment/${id}/monitor-and-tracks`,
        threat_opportunity: '/risk-management/threat-and-opportunities',
        risk_area: '/risk-management/risk-areas',
      },
    },
    //created by me
    incident_reporting: {
      incident: '/risk-management/incident-reporting',
      IncidentShow: (id) => `/risk-management/incident-reporting/${id}`,
      DelIncident: '/risk-management/incident-reporting',
      bulk_delete: '/risk-management/incident-reporting-bulk-delete',
    },
    risk_change_request: {
      crud: '/risk-management/risk-change-requests',
      riskchangeview: (id) => `/risk-management/risk-change-requests/${id}`,
      bulk_delete: '/risk-management/risk-change-request-bulk-delete',
    },
    risk_stackholder_feedback: {
      crud: '/risk-management/stakeholder-feedback',
      stakehodlerShow: (id) => `/risk-management/stakeholder-feedback/${id}`,
    },
    risk_escalation: {
      crud: '/risk-management/risk-escalation',
      escalation_levels: '/risk-management/escalation-levels',
      escalation_levels_create: '/risk-management/escalation-levels',
      esclation_Show: (id) => `/risk-management/risk-escalation/${id}`,
    },
    risk_priotization: {
      crud: '/risk-management/risk-prioritization',
      priotization_Show: (id) => `/risk-management/risk-prioritization/${id}`,
    },
    risk_response_team: {
      crud: '/risk-management/risk-team-assignment',
      response_team_Show: (id) => `/risk-management/risk-team-assignment/${id}`,
    },
    quaterly_review: {
      crud: '/risk-management/quarterly-risk-review',
      quaterly_review_Show: (id) => `/risk-management/quarterly-risk-review/${id}`,
    },
    mitigation_survey: {
      crud: '/risk-management/risk-mitigation-survey',
      mitigation_survey_Show: (id) => `/risk-management/risk-mitigation-survey/${id}`,
    },
    risk_Learning_Insights: {
      crud: '/risk-management/risk-learning-insight',
      risk_Learning_Insights_Show: (id) => `/risk-management/risk-learning-insight/${id}`,
    },
    risk_trend_analysis: {
      crud: '/risk-management/risk-trend-analysis-report',
      risk_trend_analysis_Show: (id) => `/risk-management/risk-trend-analysis-report/${id}`,
    },
    mitigation_budget_request: {
      crud: '/risk-management/risk-mitigation-budget-request',
      mitigation_budget_request_Show: (id) =>
        `/risk-management/risk-mitigation-budget-request/${id}`,
    },
  },
  job_costing: {
    get_list: '/job-costing',
    setting_customs: '/job-costing-custom-fields',
    setting: '/job-costing-settings',
    setting_post: '/job-costing-settings',
    update: '/job-costing-update',
    undo_last_drop: '/detach-job-costing',
    email: '/job-costing-mail',
  },

  accounting: {
    projects: {
      get_list: '/company/projects',
      post_list: '/company/projects',
      delete: '/company/projects',
    },
    users: {
      get_employee: '/project',
      get_users: '/company/projects',
      get_project_managers: '/users',
      post_project_manager: '/accounting/users',
      get_pm: '/ac/users',
      get_roles: '/ac/project-roles',
    },
    customers: {
      get_list: '/company/customers',
      post_list: '/company/customers',
      delete: '/company/customers',
      bulk_delete: '/company/customers/bulk-delete',
      get_countries: '/countries',
      get_states: (id) => `/countries/${id}/states`,
    },
    vendors: {
      get_list: '/accounting/vendors',
    },
    expenses: {
      get_list: '/accounting/expenses',
      post_list: '/accounting/expenses',
      delete: '/accounting/expenses',
      //dropdowms
      get_employee_list: '/company/employees',
      get_project_list: '/company/projects',
      get_departments_list: '/accounting/departments',
      add_departments_list: '/accounting/departments',
      get_category_list: '/accounting/expense-categories',
      get_sub_category_list: '/accounting/expense-categories',
      add_category_list: '/accounting/expense-categories',
      add_sub_category_list: '/accounting/expense-categories',
      get_cost_center_list: '/accounting/cost-centers',
      add_cost_center_list: '/accounting/cost-centers',
      charts_of_account_list: '/accounting/account-charts',
    },
    bank_information: {
      get_list: '/accounting/bank-information',
      show_list: '/accounting/bank-information',
      post_list: '/accounting/bank-information',
      delete: '/accounting/bank-information',
    },

    dashboard: {
      get_details: '/accounting/accounting_dashboard',
    },

    documents: {
      get_list: '/accounting/accounting-documents',
      create_new: '/accounting/tag-and-folders',
      post_request: '/accounting/accounting-documents',
      delete: '/accounting/accounting-documents',
      get_tag_fodlers: '/accounting/tag-and-folders',
      store_tag_fodlers: '/accounting/tag-and-folders',
      get_all_users: '/company/users',
      get_users: '/users',
    },
    bankReconcilation: {
      get_list: '/accounting/accounting-documents',
      post_list: '/accounting/bank-reconciliation',
    },
    employee: {
      get_list: '/company/employees',
      delete: '/company/global-employees',
      post_list: '/company/employees',
    },
    finance_statement: {
      get_list: '/accounting/financial-statements-show',
      post_list: '/accounting/financial-statements',
      delete: '/accounting/financial-statements',
    },
    finance_statement_view: {
      get_list: '/accounting/financial-statements-show',
    },
    income_statement: {
      get_list: '/accounting/income-statement',
    },
    balance_sheet: {
      get_list: '/accounting/balance_sheet',
    },
    profit_loss: {
      get_list: '/accounting/profit_loss_statement',
    },
    payroll: {
      weeklyPayroll: {
        get_payrolls: '/accounting/weekly-payrolls',
        post_payrolls: '/accounting/weekly-payrolls',
        update_payrolls: '/accounting/weekly-payrolls',
        get_time_sheet: '/accounting/weekly-time-sheet-report',
        weekly_view_create: '/accounting/weekly-payrolls',
      },
      certifiedPayroll: {
        get_list: '/accounting/certified-payrolls',
      },
      runPayroll: {
        get_list: '/accounting/run-payroll',
      },
      payrollTaxes: {
        get_list: '/accounting/payroll-taxes',
      },
      salesTax: {
        get_list: '/accounting/sales-taxes',
      },
      generate_payroll: {
        get_user_list: '/company/users',
        get_employee_list: '/accounting/employee-payrolls',
        delete: '/accounting/employee-payrolls',
        emoployee_view: '/accounting/employee-payrolls',
        get_payroll_weekly_timesheet: '/accounting/generate-payroll-weekly-timesheet',
        create_payroll: '/accounting/employee-payrolls',
        create_issue_payroll: '/accounting/employee-payrolls',
        create_settings: '/accounting/employee-payroll-settings', 
        post_deduction_tax: '/accounting/payroll-tax-details', 
        assign_share_users: '/accounting/employee-payrolls', 
        status_change: '/accounting/employee-payrolls', 
        preview_slip: '/accounting/employee-payrolls', 
      },
    },
    general_ledger: {
      post_list: '/accounting/store-general-ledger',
      get_list: '/accounting/general-ledger',
      upadte_list: '/accounting/general-ledger',
      get_cash_flow: '/accounting/cash-flow',
    },
    account_receiveable: {
      propsal: {
        get_list: '/accounting/account-receivable/proposals',
      },
      invoice: {
        get_list: '/accounting/account-receivable/invoices',
        get_follow_up_list: '/accounting/account-receivable/invoices',
        post_follow_up: '/accounting/invoice',
        update_invoice: '/accounting/invoice',
      },
      payment_requisition: {
        // get_list_sov: '/accounting/account-receivable/sov-forms',
        get_list_sov: '/accounting/sov-follow-ups',
        post_list_sov: '/accounting/sov-form',
      },
      cost_codes: {
        get_category_list: '/accounting/cost-codes',
        get_activities: '/accounting/cost-codes-activities',
      },
      change_order: {
        get_category_list: '/accounting/change-order',
        get_activities: '/accounting/change-order-activities',
      },
    },

    account_payable: {
      purchase_order: {
        get_list: '/accounting/account-payable/purchase-orders',
      },
      purchase_order_invoice: {
        get_list: '/accounting/purchase-orders/',
        post_list: '/accounting/purchase-orders/',
      },
      subcontractor_amount: {
        get_list: '/accounting/account-payable/subcontractors-agreements',
      },
      subcontractor_invoice: {
        get_list: '/accounting/subcontractor-agreements/',
        post_list: '/accounting/subcontractor-agreements/',
      },
      work_order: {
        get_list: '/accounting/account-payable/work-orders',
      },
      work_order_invoice: {
        get_list: '/accounting/work-orders/',
        post_list: '/accounting/work-orders/',
      },
      invoices: {
        get_list: '/accounting/all-invoices',
        delete: '/accounting/all-invoices',
      },
    },
    taxes: {
      business_taxes: {
        crud_list: '/accounting/tax-type/1/business-and-misc-taxes',
      },
      misc_taxes: {
        crud_list: '/accounting/tax-type/2/business-and-misc-taxes',
      },
    },
    auditLogs: {
      get_list: '/accounting/audit-logs',
    },

    settings: {
      get_list: '/accounting/accounting-settings',
      post_list: '/accounting/accounting-settings',
    },

    inventory: {
      assests: {
        get_list: '/accounting/assets',
        post_list: '/accounting/assets',
        update_list: '/accounting/assets',
        delete: '/accounting/assets',
      },
      materials: {
        get_list: '/ac/performance/projects',
        post_list: '/ac/performance/projects',
        category_list: '/accounting/performance/performance-material-categories',
        performance_materials: (id) =>
          `/accounting/performance/performance-material-categories/${id}/performance-materials`,
      },
      equipments: {
        get_list: '/ac/performance/projects',
        post_list: '/ac/performance/projects',
        category_list: '/accounting/performance/performance-equipment-categories',
        performance_materials: (id) =>
          `/accounting/performance/performance-equipment-categories/${id}/performance-equipments`,
      },
      tools: {
        get_list: '/accounting/tools',
        post_list: '/accounting/tools',
        update_list: '/accounting/tools/update',
        delete: '/accounting/tools',
      },
    },
  },

  organizational_hierarchy: {
    crud_heirarchy: '/company/cooperate-management',
    parent_child_heirarchy: '/company/cooperate-management-parent',
    parent_child_heirarchy_attach_nodes: '/company/attach_cooperate',
    detach_nodeds: '/company/cooperate_detach',
    nodes_positions: '/company/cooperate-management-positions',
    
  },
  submittals: {
    users: '/users',
    app_role: '/app/project-roles',
    get_project: '/get-current-company-project',
    default_submittals_permission: '/default-user-assign-permission',
    dashboard: {
      counts: '/submittal-dashboard-counts',
    },
    submittals: {
      submittals: '/submittals',
      submittals_recreate: '/recreate-submittal',
      get_library_submittals: '/submittal-library',
      get_specifications_list: '/submittal/specifications-list',
      process_pdf: (agency) => `/${agency}/process-pdf`,
      send_to_claude: '/send-to-claude',
      pdf_status: '/pdf-status',
      submittals_import: '/submittals-import',
      delete: '/submittals',
      bulk_delete: '/submittal-management/bulk-delete',
      users: '/users',
      get_trades_list: '/submittal/trades-list',
      add_trade: '/trades',
      get_package_list: '/submittal-package',
      add_package: '/submittal-package',
      get_submittal: (id) => `/submittals/${id}/edit`,
      get_cost_code_category: '/submittal/cost-code-category',
      app_role: '/app/project-roles',
      import_library_submittal: '/submittals-import-library',
      update_submittals_status_and_assign: (id) => `/update-submittals-status-and-assign/${id}`,
    },
    library: {
      library: '/submittal-library',
      get_specifications_list: '/submittal/specifications-list',
      process_pdf: (agency) => `/${agency}/process-pdf`,
      send_to_claude: '/send-to-claude',
      pdf_status: '/pdf-status',
      submittals_import: '/submittals-import',
      delete: '/submittal-library',
      bulk_delete: '/submittal-management/bulk-delete',
      users: '/users',
      get_trades_list: '/submittal/trades-list',
      add_trade: '/trades',
      get_package_list: '/submittal-package',
      add_package: '/submittal-package',
      get_submittal: (id) => `/submittal-library/${id}/edit`,
      get_cost_code_category: '/submittal/cost-code-category',
      app_role: '/app/project-roles',
    },
    package: {
      package: '/submittal-package',
      delete: '/submittal-package',
      bulk_delete: '/submittal-management/bulk-delete',
      get_package: (id) => `/submittal-package/${id}/edit`,
      submittals: '/submittals',
      users: '/users',
      invite_user: '/submittal-package-assign/invite',
    },
    transmittal: {
      get_list: '/transmittal',
      delete: '/transmittal',
      post_transmittal: '/transmittal',
      put_transmittal: '/transmittal',
      bulk_delete: '/submittal-management/bulk-delete',
      users: '/users',
      get_package_list: '/submittal-package',
      add_package: '/submittal-package',
      get_submittal: (id) => `/submittals/${id}/edit`,
      get_transmittal: (id) => `/transmittal/${id}/edit`,
      submittals: '/submittals',
    },
  },

  ganttChart: {
    get_data: '/gantt-chart-cost-codes',
    post_catgory: '/gantt-chart/cost-code-categories',
    post_task: '/gantt-chart/cost-code-tasks',
    assign_hours: '/gantt-chart/employee-resource',
    onDrop: '/gantt-chart-task/update-on-drag',
    onAddLink: '/gantt-chart/task-link',
    assign_labours: '/gantt-chart/assign-labor-on-date',
    assign_materials: '/gantt-chart-task/material-datewise-assignment',
    assign_equipments: '/gantt-chart-task/equipment-datewise-assignment',
    assign_subcontractor: '/gantt-chart-task/subcontractor-datewise-assignment',
    assign_othercost: '/gantt-chart-task/other-cost-datewise-assignment',
    get_trade_worker_titles: '/trade-worker-titles',
    post_trade_worker_title: '/trade-worker-titles',
    post_cost_code_activities: '/gantt-chart/cost-code-activities',
    add_trade: '/trades',
    get_trades_list: '/submittal/trades-list',
  },
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
};
